import type { Issue } from '@openrocket-web/physics';
import type { Analysis } from '../state/derived';
import type { Fmt } from './format';

interface Props {
  readonly analysis: Analysis;
  readonly fmt: Fmt;
}

export function StabilityPanel({ analysis, fmt }: Props): JSX.Element {
  const { stability, mass, length, refDiameter, issues } = analysis;
  const margin = stability?.margin;
  const level = margin === undefined || !Number.isFinite(margin) ? 'unknown' : margin < 0 ? 'bad' : margin < 1 ? 'warn' : margin > 6 ? 'warn' : 'ok';
  const errors = issues.filter((i): i is Issue => i.severity === 'error');

  return (
    <section aria-labelledby="stab-title" className="panel">
      <h2 id="stab-title">Estabilidad</h2>
      <dl className="stats" aria-live="polite">
        <div>
          <dt>Longitud</dt>
          <dd>{fmt.dimension(length)}</dd>
        </div>
        <div>
          <dt>Diámetro de referencia</dt>
          <dd>{fmt.dimension(refDiameter)}</dd>
        </div>
        <div>
          <dt>Masa de lanzamiento</dt>
          <dd>{mass === undefined ? '—' : fmt.massText(mass.total.mass)}</dd>
        </div>
        <div>
          <dt>CG</dt>
          <dd data-testid="cg">{stability === undefined ? '—' : fmt.dimension(stability.cgX)}</dd>
        </div>
        <div>
          <dt>CP</dt>
          <dd data-testid="cp">{stability === undefined || !Number.isFinite(stability.cpX) ? '—' : fmt.dimension(stability.cpX)}</dd>
        </div>
        <div className={`stats__margin stats__margin--${level}`}>
          <dt>Margen de estabilidad</dt>
          <dd data-testid="margin">{margin === undefined || !Number.isFinite(margin) ? '—' : `${margin.toFixed(2)} calibres`}</dd>
        </div>
      </dl>

      {stability !== undefined && stability.warnings.length > 0 && (
        <ul className="issue-list issue-list--warning" aria-label="Avisos de estabilidad">
          {stability.warnings.map((w) => (
            <li key={w}>{w}</li>
          ))}
        </ul>
      )}
      {mass !== undefined && mass.warnings.length > 0 && (
        <ul className="issue-list issue-list--warning" aria-label="Avisos de masa">
          {mass.warnings.map((w) => (
            <li key={w}>{w}</li>
          ))}
        </ul>
      )}
      {errors.length > 0 && <p className="muted small">El diseño tiene {errors.length} error{errors.length === 1 ? '' : 'es'}; se detallan junto a la simulación.</p>}
    </section>
  );
}
